export default __webpack_public_path__ + "static/media/Icon-WorkOrder-White.fd7ad7a2.svg";